import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { QrCode, Download, Share2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";

const SIZE = 720;

function poster(qr) {
  const c = document.createElement("canvas");
  c.width = SIZE; c.height = SIZE + 200;
  const g = c.getContext("2d");
  g.fillStyle = "#ffffff"; g.fillRect(0, 0, c.width, c.height);
  g.fillStyle = "#0f1710"; g.textAlign = "center";
  g.font = "bold 44px sans-serif"; g.fillText("Madonna Store", SIZE / 2, 70);
  g.font = "28px sans-serif"; g.fillStyle = "#475569"; g.fillText("App tecnici – inquadra per accedere", SIZE / 2, 115);
  g.drawImage(qr, 90, 150, SIZE - 180, SIZE - 180);
  g.font = "22px sans-serif"; g.fillText(`${window.location.host}/login`, SIZE / 2, SIZE + 30);
  g.fillText("Accedi con email e password ricevute dall'ufficio", SIZE / 2, SIZE + 70);
  return c;
}

export function AppAccessQr() {
  const ref = useRef(null);
  const url = `${window.location.origin}/login`;
  const blob = () => new Promise((res) => poster(ref.current.querySelector("canvas")).toBlob(res, "image/png"));
  const download = async () => {
    const u = URL.createObjectURL(await blob());
    Object.assign(document.createElement("a"), { href: u, download: "qr-accesso-app-madonna-store.png" }).click();
    URL.revokeObjectURL(u);
  };
  const share = async () => {
    const file = new File([await blob()], "qr-accesso-app.png", { type: "image/png" });
    const text = `Accedi all'app Madonna Store: ${url}`;
    try {
      if (navigator.canShare?.({ files: [file] })) await navigator.share({ files: [file], text });
      else window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank");
    } catch (e) {
      if (e.name !== "AbortError") toast.error("Condivisione non riuscita");
    }
  };
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" className="rounded-full" data-testid="app-qr-open-button"><QrCode className="h-4 w-4" /> QR accesso app</Button>
      </DialogTrigger>
      <DialogContent className="max-w-sm" data-testid="app-qr-dialog">
        <DialogHeader>
          <DialogTitle>QR accesso all'app</DialogTitle>
          <DialogDescription>Inviatelo ai dipendenti: inquadrandolo aprono la pagina di accesso e possono installare l'app sul telefono.</DialogDescription>
        </DialogHeader>
        <div ref={ref} className="mx-auto rounded-2xl border bg-white p-4" data-testid="app-qr-code">
          <QRCodeCanvas value={url} size={SIZE} level="M" marginSize={2} style={{ width: 240, height: 240 }} />
        </div>
        <p className="break-all text-center font-mono text-xs text-slate-500" data-testid="app-qr-url">{url}</p>
        <div className="flex gap-2">
          <Button className="flex-1 rounded-full" onClick={download} data-testid="app-qr-download-button"><Download className="h-4 w-4" /> Scarica</Button>
          <Button variant="outline" className="flex-1 rounded-full" onClick={share} data-testid="app-qr-share-button"><Share2 className="h-4 w-4" /> Condividi</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
